/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { ContactDisplayRole } from '../enums/contact-display-role';
import { AccountEntity } from './account-entity';
import { CalendarEntity } from './calendar-entity';
import { UserEntity } from './user-entity';
export class ContactEntity extends Entity {
  accounts: AccountEntity[] = [];
  address: string | null = null;
  availabilityNotificationOptOut: boolean | null = null;
  benchNotificationOptOut: boolean | null = null;
  calendar: CalendarEntity | null = null;
  canViewPricing: boolean = false;
  city: string | null = null;
  country: string | null = null;
  email: string | null = null;
  firstName: string | null = null;
  hubspotIntake: boolean = false;
  id: string = '';
  jobRole: string | null = null;
  lastName: string | null = null;
  lastOutreachAt: string | null = null;
  mobileNumber: string | null = null;
  phoneNumber: string | null = null;
  salesforceId: string | null = null;
  state: string | null = null;
  user: UserEntity | null = null;
  welcomeEmailLastSentAt: string | null = null;
  welcomeEmailLastSentBy: string | null = null;
  welcomeEmailLastSentByUser: UserEntity | null = null;
  zip: string | null = null;
  displayRole?: ContactDisplayRole | null = null;
  fullName?: string | null = null;
  static override key = 'Contact';
  static override get schema() {
    return {
      accounts: [AccountEntity],
      calendar: CalendarEntity,
      user: UserEntity,
      welcomeEmailLastSentByUser: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Contact' in input
    ) {
      const { Contact: wrapped, ...rest } = input as {
        Contact: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}